// extracted by mini-css-extract-plugin
export default {"advantagesContainer":"Advantages_advantagesContainer__B1U13","characteristicsContainer":"Advantages_characteristicsContainer__+L4AG"};